/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import { Post } from '../Post'
import { nest } from 'd3-collection'
import './styles.scss'

const bubbleColors = {
  'carlos p.': 'blue',
  josé: 'purple', // blue, green, red, purple, orange, grey
  kks: 'blue',
  'a. rösti': 'green',
  'baume-schneider': 'red',
  cassis: 'purple',
  'beat jans': 'orange'
}

const params = new URL(document.location).searchParams

export class AppComponent extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      chatID: params.get('chat') ? params.get('chat') : null,
      groupedData: {},
      output: [],
      colorMode: false
    }
  }

  componentDidMount() {
    // console.log('componentDidMount')
    /* GET SHEET DATA VIA CLOUD STORAGE */
    fetch(
      this.state.chatID === '2'
        ? 'https://storage.googleapis.com/ta-interaktiv/messenger-chat/messages2.json'
        : this.state.chatID === '3'
        ? 'https://storage.googleapis.com/ta-interaktiv/messenger-chat/messages3.json'
        : this.state.chatID === '4'
        ? 'https://storage.googleapis.com/ta-interaktiv/messenger-chat/messages4.json'
        : this.state.chatID === '5'
        ? 'https://storage.googleapis.com/ta-interaktiv/messenger-chat/messages5.json'
        : this.state.chatID === '6'
        ? 'https://storage.googleapis.com/ta-interaktiv/messenger-chat/messages6.json'
        : this.state.chatID === '7'
        ? 'https://storage.googleapis.com/ta-interaktiv/messenger-chat/messages7.json'
        : this.state.chatID === '8'
        ? 'https://storage.googleapis.com/ta-interaktiv/messenger-chat/messages8.json'
        : this.state.chatID === '9'
        ? 'https://storage.googleapis.com/ta-interaktiv/messenger-chat/messages9.json'
        : 'https://storage.googleapis.com/ta-interaktiv/messenger-chat/messages.json'
    )
      .then(response => {
        if (response.ok) {
          return response.json()
        } else {
          throw new Error('Cloud Function Data was not OK')
        }
      })
      .then(responseData => {
        const groupedData = nest()
          .key(function(d) {
            return d.Date
          })
          .entries(responseData)
        console.log('groupedData:', groupedData)

        this.setState({ groupedData: groupedData }, function() {
          console.log('groupedData', this.state.groupedData)
          const output = this.state.groupedData.map(function(post, index) {
            // console.log('message', message)
            return (
              <Post
                date={post.key}
                name={post.values[0].Name}
                bubbles={post.values}
                side={index % 2 === 0 ? 'left' : 'right'}
                key={index}
                bubbleColors={bubbleColors}
              />
            )
          })
          this.setState({ output: output })
        })
      })

    /* DETECT DARK MODE (USER SETTINGS ON WEBPAGE) */
    window.addEventListener('message', event => {
      if (
        [
          'https://www.tagesanzeiger.ch',
          'https://www.bernerzeitung.ch',
          'https://www.tdg.ch',
          'https://www.derbund.ch',
          'https://www.24heures.ch',
          'https://www.bazonline.ch',
          'https://www.landbote.ch',
          'https://www.thunertagblatt.ch',
          'https://www.berneroberlaender.ch',
          'https://www.langenthalertagblatt.ch',
          'https://www.zsz.ch',
          'https://www.landbote.ch',
          'https://www.zuonline.ch',
          'https://www.thunertagblatt.ch'
        ].indexOf(event.origin) !== -1
      ) {
        // this check is needed because of https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage#security_concerns
        if (event.data.type === 'colorMode') {
          this.setState({ colorMode: event.data.mode }) // will be the string 'dark' or 'light'
        }
      }
    })
  }

  render() {
    return (
      <div
        className={
          'index ' +
          (!this.state.colorMode
            ? ''
            : this.state.colorMode === 'light'
            ? ' light'
            : ' dark')
        }
      >
        <section className='discussion'>
          {this.state.output}

          {/*
          <Post
            date='24. Februar, 15:12'
            name='Mathias'
            bubbles={['Message 1', 'Message 2', 'Message 3']}
            side='left'
          />

          <Post
            date='24. Februar, 16:12'
            name='Nina'
            bubbles={['Message 1', 'Message 2', 'Message 3']}
            side='right'
          />

          <Post
            date='24. Februar, 16:12'
            name='nina'
            bubbles={['Message 1', 'Message 2', 'Message 3']}
            side='left'
          />
          */}

          {/*
          <div className='post left'>
            <div className='timestamp'>2. Februar, 20:22</div>
            <div className='block'>
              <div className='person'>
                <img
                  className='ui avatar image'
                  src={require('../../images/mathias.jpg')}
                />
                <div className='name'>Mathias</div>
              </div>
              <div className='bubble first'>
                Hoi, das ist ein Beispiel für unser Messenger Chat Embed.
              </div>
            </div>
          </div>

          <div className='post right'>
            <div className='timestamp'>2. Februar, 20:23</div>
            <div className='block'>
              <div className='bubble first'>Oh, sehr cool!</div>
              <div className='person'>
                <img
                  className='ui avatar image'
                  src={require('../../images/nina.jpg')}
                />
                <div className='name'>Nina</div>
              </div>
              <div className='bubble last'>
                Kann ich das in meinen Artikel einbinden?
              </div>
            </div>
          </div>

          <div className='post left'>
            <div className='timestamp'>2. Februar, 20:29</div>
            <div className='block noimage'>
              <div className='bubble first'>
                Ja, ich schicke dir dann den iframe Code...
              </div>
              <div className='bubble middle'>Sollte ganz einfach gehen 😃</div>
              <div className='bubble last'>
                Neue Chat-Nachrichten kann man dann über ein Google-Sheet
                erfassen. Aber das ist noch nicht ganz fertig.
              </div>
            </div>
          </div>

          <div className='post right'>
            <div className='timestamp'>2. Februar, 20:31</div>
            <div className='block noimage'>
              <div className='bubble first'>
                Tönt gut, melde dich doch einfach wenn alles bereit ist.
              </div>
            </div>
          </div>

          <div className='post left'>
            <div className='timestamp'>2. Februar, 20:33</div>
            <div className='block noimage'>
              <div className='bubble first'>👍🏻</div>
            </div>
          </div>
          */}
        </section>
      </div>
    )
  }
}
